module.exports = __webpack_public_path__ + "img/logo.4926494f.jpg";